import { makeAutoObservable, runInAction } from "mobx";
import { COMPANY_ROLE_ENUM, CompanyEntity, USER_STATUS_ENUM } from "interfaces";
import { getCompanyById, getUserById } from "services";
import { NormalizedError } from "services/api/errorHandler";
import { statusFetching } from "services/authClient/constants/types";
import { components } from "types/openapi";

export class ProfileStore {
  public user: components["schemas"]["UserDto"] = {
    id: "",
    companyUserDto: [],
    surname: "",
    name: "",
    secondName: "",
    phone: "",
    email: "",
    status: USER_STATUS_ENUM.DRAFT,
    createdAt: "",
    statusDate: "",
    roles: [],
  };

  public company: CompanyEntity = {
    id: "",
    userCompanyDto: [],
    statusDate: "",
    status: "DRAFT",
    companyName: "",
    companyRegistrationNumber: "",
    inn: "",
    kpp: "",
    role: COMPANY_ROLE_ENUM.CUSTOMER,
    createdAt: "",
    documents: {},
    address: "",
    defaultQuoteExpDuration: {},
    isResident: false,
    type: "COMPANY",
    isForeignOrg: false,
    isOnlyTaxResidentRF: false,
    isControlPersonsRF: false,
    phone: "",
    email: "",
    contractNumber: "",
    contractDate: "",
    beneficiaryCreated: false,
  };

  public fetchStatus: statusFetching = "init";
  public fetchError?: NormalizedError;

  constructor() {
    makeAutoObservable(this);
  }

  get isPending() {
    return this.fetchStatus === "fetching";
  }

  fetchProfileById = async (userId: string, companyId: string) => {
    runInAction(() => {
      this.fetchStatus = "fetching";
      this.fetchError = undefined;
    });

    try {
      const [userRes, companyRes] = await Promise.all([getUserById({ id: userId }), getCompanyById({ id: companyId })]);

      runInAction(() => {
        this.user = userRes;
        this.company = companyRes;
        this.fetchStatus = "success";
      });
    } catch (error: any) {
      runInAction(() => {
        this.fetchStatus = "error";
        this.fetchError = error;
      });
    }
  };
}
